import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Types
import { NewBannerType } from "../../types/Banners";

type BannerState = {
  bannerList: NewBannerType[] | [];
};

const initialState: BannerState = {
  bannerList: [],
};

export const bannerSlice = createSlice({
  name: "banner",
  initialState,
  reducers: {
    setBannerList(state, action: PayloadAction<NewBannerType[]>) {
      state.bannerList = action.payload;
    },
  },
});

export const { setBannerList } = bannerSlice.actions;

export default bannerSlice.reducer;

// import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// //Types
// import { BannerType, NewBannerType } from '../../types/Banners';

// type BannerState = {
//     bannerList: BannerType[] | [];
// };

// const initialState: BannerState = {
//     bannerList: [],
// };

// export const bannerSlice = createSlice({
//     name: 'banner',
//     initialState,
//     reducers: {
//         setBannerList(state, action: PayloadAction<BannerType[]>) {
//             state.bannerList = action.payload;
//         },
//     },
// });

// export const { setBannerList } = bannerSlice.actions;

// export default bannerSlice.reducer;
